import { AlertTriangle } from 'lucide-react';

interface GenieSeatsNoticeProps {
  counts: { active: number; eligible: number } | undefined;
  allowed: number;
}

const genies = (count: number) => `${count} ${count === 1 ? 'genie' : 'genies'}`;

export const GenieSeatsNotice = ({ counts, allowed }: GenieSeatsNoticeProps) => {
  if (!counts) return null;

  const expected = Math.min(allowed, counts.eligible);
  if (counts.active === expected) return null;

  const isOver = counts.active > expected;

  return (
    <div className="rounded-[10px] border border-genie-accent/40 bg-genie-accent/10 p-5">
      <div className="flex items-center gap-2 mb-2">
        <AlertTriangle className="h-5 w-5 text-genie-accent-dark" />
        <h2 className="text-base font-semibold text-gray-900 m-0">
          {isOver
            ? `${genies(counts.active - expected)} active beyond the seats`
            : `${genies(expected - counts.active)} covered by seats but inactive`}
        </h2>
      </div>
      <p className="text-sm text-gray-700">
        {genies(counts.active)} active, seats allow {genies(allowed)} (1 free + plan + extra across live subscriptions).
        {' '}Changing Extra Quantity doesn't activate or deactivate genies — adjust them manually if needed.
      </p>
    </div>
  );
};
